module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_3-c4b8cd72718d850e93708c4027360a43.jpg";